import { Injectable } from '@angular/core';
import { MingleService } from '@totvs/mingle';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppinitService {
  constructor(private mingleService: MingleService) {}

  mingleConfiguration(): Promise<string> {
    return new Promise((resolve, reject) => {
      const server = environment.server;
      const appId = environment.appIdentifier;
      const web = true;
      this.mingleService
        .init(server, appId, web)
        .then(() => {
          resolve('Mingle Service Init');
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}
